import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/admin")({
  component: GroupAdminLayout,
});

function GroupAdminLayout() {
  return <Outlet />;
}
